"use strict";

exports.__esModule = true;
var _NewLogbookComment = require("./NewLogbookComment");
Object.keys(_NewLogbookComment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewLogbookComment[key]) return;
  exports[key] = _NewLogbookComment[key];
});
var _NewLogbookCommentForm = require("./NewLogbookCommentForm");
Object.keys(_NewLogbookCommentForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewLogbookCommentForm[key]) return;
  exports[key] = _NewLogbookCommentForm[key];
});